import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type ProcessDefinitionEvents =
  | 'EXPORT_PROCESS_DEFINITION_RESULT'
  | 'IMPORT_PROCESS_DEFINITION_RESULT'
  | 'DUPLICATE'
  | 'RESTORE'
  | 'DISCARD'
  | 'DELETE'
  | 'AUTO_COMPLETE_WHEN_ASSIGNEE_IS_INITIATOR'
  | 'AUTO_COMPLETE_WHEN_INSUFFICIENT_MANAGER_LEVELS';

export const processDefinition: Record<ProcessDefinitionEvents, MixpanelEvent> = {
  EXPORT_PROCESS_DEFINITION_RESULT: {
    eventDescription: 'Export Process Definition Result',
    eventKey: 'export-process-definition-result',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  IMPORT_PROCESS_DEFINITION_RESULT: {
    eventDescription: 'Import Process Definition Result',
    eventKey: 'import-process-definition-result',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  DUPLICATE: {
    eventDescription: 'Duplication Process Definition',
    eventKey: 'duplicate-process-definition',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  RESTORE: {
    eventDescription: 'Restore Process Definition',
    eventKey: 'restore-process-definition',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  DISCARD: {
    eventDescription: 'Discard Process Definition',
    eventKey: 'discard-process-definition',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  DELETE: {
    eventDescription: 'Delete Process Definition',
    eventKey: 'delete-process-definition',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  AUTO_COMPLETE_WHEN_ASSIGNEE_IS_INITIATOR: {
    eventDescription: 'Auto Complete When Assignee Is Initiator',
    eventKey: 'auto-complete-when-assignee-is-initiator',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  },
  AUTO_COMPLETE_WHEN_INSUFFICIENT_MANAGER_LEVELS: {
    eventDescription: 'Auto Complete When Insufficient Manager Levels',
    eventKey: 'auto-complete-when-insufficient-manager-levels',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_BUTTON
  }
} as const;
